export default "__VITE_ASSET__DIt5s9Gk__"